export const frameData = {
    delta: 0,
    timestamp: 0,
    isProcessing: false,
}
